import React from 'react';
import { ModalTypes } from '../../../reducers/modal';
import { KattanaAPI } from '../../../store/createStore';

export const enableLimitsOverlay = (widget: any, chain: string, wallet: string, address: string, showModal: Function) => {
  let showMarks = false;

  const toggleMarks: HTMLButtonElement = widget.createButton();
  toggleMarks.setAttribute('title', 'Marks');
  toggleMarks.textContent = 'Limits';
  widget._options.datafeed.setButton(toggleMarks);
  let shapeIds: string[] = [];
  const chart = widget.chart();

  const removeShapes = () => {
    showMarks = false;
    shapeIds.map(s => {
      chart.removeEntity(s);
    });
    shapeIds = [];
  };

  toggleMarks.addEventListener('click', async () => {
    const usdConversion = widget._options.datafeed.usdConversion;

    if (!showMarks) {
      try {
        const marks = await KattanaAPI.fetchOverlayLimitOrders(
          wallet,
          chain,
          address
        );

        if (typeof marks === 'object' && marks !== null && marks['error']) {
          // showModal(ModalTypes.upgrade, {});
          return;
        }

        marks.forEach((m: any) => {
          const shapeId = chart.createShape(
            {
              time: m.timestamp,
              price: usdConversion ? m.price_usd : m.price,
              channel: 'high',
            },
            {
              shape: 'horizontal_line',
              overrides: {
                linecolor: m.gt ? '#D32F2F' : '#388E3C',
              },
            }
          );
          shapeIds.push(shapeId);
        });
        showMarks = true;
      } catch (e) {
        console.log(e);
      }
    } else {
      removeShapes();
    }
  });

  return () => {
    removeShapes();
  };
};
